package com.neurobs.js.util

import com.neurobs.errors.Result
import com.neurobs.http.BodyData
import com.neurobs.js.ccab.ResponseHandlers
import com.neurobs.js.http.ArrayBufferBody
import com.neurobs.react.ServerDataAttribute
import org.scalajs.dom.{AudioBuffer, AudioContext}

import scala.concurrent.{Future, Promise}

object ServerResponseUtil {

  def emptyHandler() = {}
  def emptyStringHandler(string: String) = {}

  def serverDataObjectResultHandler[T](serverDataAttribute: ServerDataAttribute[T]) = {
    handleObjectResultResponse[T](
      handleObject = serverDataAttribute.setData(_),
      onAnyError = serverDataAttribute.setError(_)
    )
  }

  def handleObjectResultResponse[T](
                                     handleObject: T => Unit,
                                     onAnyResponse: () => Unit = emptyHandler,
                                     onObjectError: String => Unit = emptyStringHandler,
                                     onServerError: String => Unit = emptyStringHandler,
                                     onAnyError: String => Unit = emptyStringHandler
                                   ) = {
    ResponseHandlers.handleObjectResultResponse[T](
      handleObject = {obj =>
        onAnyResponse()
        handleObject(obj)
      },
      handleObjectError = {error =>
        onAnyResponse()
        onObjectError(error)
        onAnyError(error)
      },
      handleServerError = {error =>
        onAnyResponse()
        onServerError(error)
        onAnyError(error)
      }
    )
  }

  def handleObjectResponse[T](
                               handleObject: T => Unit,
                               onAnyResponse: () => Unit = emptyHandler,
                               onError: String => Unit = emptyStringHandler
                             ) = {
    ResponseHandlers.handleObjectResponse[T](
      handleObject = {obj =>
        onAnyResponse()
        handleObject(obj)
      },
      handleServerError = {error =>
        onAnyResponse()
        onError(error)
      }
    )
  }

  def decodeAudioData(bodyResult: Result[BodyData])(implicit context: AudioContext): Future[Result[AudioBuffer]] = {
    bodyResult match {
      case Left(e) => Future.successful(Left(e))
      case Right(body) =>
        try {
          val promise = Promise[Result[AudioBuffer]]
          val audioFile = body.asInstanceOf[ArrayBufferBody].data
			 context.decodeAudioData(audioFile,
            b => promise.success(Right(b)),
            () => promise.success(Left("The audio data could not be decoded."))
          )
          promise.future
        }
        catch {
          case e: Throwable => Future.successful(Left(e))
        }
    }
  }

}
